import { createStorageKeySchema } from '@dynamic-labs-sdk/client/core';
import * as z from 'zod/mini';

import { PHANTOM_PENDING_REQUEST_STORAGE_KEY } from '../../phantomRedirect.constants';

/**
 * Storage schema for tracking pending Phantom wallet requests.
 * This temporary data is used to match redirect responses with their
 * originating requests and includes the encryption keys needed for decryption.
 */
export const pendingRequestStorageKeySchema = createStorageKeySchema({
  key: PHANTOM_PENDING_REQUEST_STORAGE_KEY,
  schema: z.object({
    dappPublicKey: z.string(),
    dappSecretKey: z.string(),
    message: z.optional(z.string()),
    method: z.string(),
    requestId: z.string(),
    timestamp: z.number(),
    walletAddress: z.optional(z.string()),
  }),
});
